import React from "react";
import { Field, Fields } from "redux-form";
import { Col } from "react-bootstrap";
import NumberInput from "MODULES/shared/components/Forms/NumberInput/NumberInput";
import { TOTAL_CYCLES, TOTAL_HOURS } from "MODULES/parts/constants";

export function TotalTimeFields() {
  return [
    <Col md={3}>
      <div className="form-group">
        <Field
          name={TOTAL_HOURS}
          component={NumberInput}
          roundDigits={0}
          label="Time Since New (Hours)"
        />
      </div>
    </Col>,
    <Col md={3}>
      <div className="form-group">
        <Field
          name={TOTAL_CYCLES}
          component={NumberInput}
          roundDigits={0}
          label="Cycles Since New"
        />
      </div>
    </Col>
  ];
}

export default () => (
  <Fields names={["total_hours", "total_cycles"]} component={TotalTimeFields} />
);



// WEBPACK FOOTER //
// ./app/modules/parts/components/CreatePart/TotalTimeFields.jsx